module.exports = __webpack_public_path__ + "static/media/the-promised-land-desktop.a465901c.jpg";